import { days } from "../../../../utils/constants";

/*
 * Reuses the canonical day list from utils/constants — `value` is the payload
 * day key V1's /add/batch already uses (mon/tue/…). Only the display order
 * changes: the design's chips run Sun-first.
 */
const DISPLAY_ORDER = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

export const WEEK_DAYS = DISPLAY_ORDER?.map((value) =>
  days?.find((day) => day?.value === value),
).filter(Boolean);

export const dayLabel = (value) =>
  WEEK_DAYS?.find((day) => day?.value === value)?.text ?? value;

/*
 * A class is 60 minutes: the backend refuses any other length
 * (`duration-not-allowed`, R-04-02), so 1 hour is the only option and the
 * default. Kept as a string so it compares directly against the option `value`.
 */
export const DEFAULT_DURATION = "60";

export const DEFAULT_DURATION_OPTIONS = [{ value: "60", label: "1 hour" }];

/*
 * Batches made before this rule can hold another length. Edit loads them, so the
 * stored value is offered alongside 1 hour — otherwise the field renders blank
 * and the save is refused with a length the screen never showed.
 */
export const durationOptionsFor = (duration) => {
  const stored = String(duration ?? "");
  const isKnown = DEFAULT_DURATION_OPTIONS?.some((option) => option?.value === stored);
  return isKnown || !stored
    ? DEFAULT_DURATION_OPTIONS
    : [...DEFAULT_DURATION_OPTIONS, { value: stored, label: `${stored} minutes (current)` }];
};

export const HOURS = ["12", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"];

/* Same granularity rule V1 validates ("Minutes can be 00 or 30 only"). */
export const MINUTES = ["00", "30"];

export const MERIDIEMS = ["AM", "PM"];
